// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonOutline_button__HLN70"};